<div class="customers">
    <div>
        <div class="card-body">
            <div class="row">
                <div class="separator" [ngClass]="'color-back-area-' + areaNumber" style="width: 100%;margin-left: 0px;margin-bottom: 10px;margin-right: -15px;">
                    <div class="estrategia-text"><strong>{{subdimensionData?.subdimension}}</strong></div>
                </div>
            </div>
            <div *ngFor="let estrategiaData of subdimensionData.estrategias; let indice=index;">
                <div class="row">
                    <app-estrategia-anual-seguimiento [estrategiaData]="estrategiaData" [areaNumber]="areaNumber"></app-estrategia-anual-seguimiento>
                </div>
            </div>
        </div>
    </div>
</div>